// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table__wrapper>table>tbody>tr>td[data-v-3c5801ae]{padding:.5rem 1rem}", ""]);
// Exports
module.exports = exports;
